module.exports = __webpack_public_path__ + "static/media/rush_bookmark_x_front1_2x.5816741e.jpg";